const notifications = {
    title: "قائمة الاشعارات",
    markAsRead: "تحديد كمقروء",
    seeAllNotifications: "مشاهدة جميع الاشعارات",
    seeMore: "مشاهدة المزيد",
    noNotifications: "لا توجد اشعارات حاليا",
  };
  
  export default notifications;